// Observe Mutations
function waitforLayout(selector) {
  return new Promise(function (resolve) {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector (selector));
    }

    var observer = new MutationObserver(function (mutations) {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        //observer.disconnect ();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// jQuery
$(document).ready(function(){

  // Removed the default variant
  function removeOtherVariants() {

    waitforLayout('.product-list .product-card .product-card--remove').then(elm => {
      console.log('Has the element');
      $('.product-card--remove').remove();
      let removeVariantSelector = $('.product-list .product-card .variant-picker .to-remove');
      removeVariantSelector.remove();
    });
    
  }

  removeOtherVariants();
    
  function colorSwatch(){
    $(".product-list .product-card").hover(function(){
      $(this).addClass('show-color-swatches');
      $('.variant-picker__option-info .h-stack').after(`<p></p>`);
      let isSoldOut = $(this).find('.product-card__quick-buy').length;
      let hasVariants = $(this).find('.variant-picker__option-values').length;
      let hasClass = $(this).find(".variant-picker__option-values a.is-selected").length;
      // console.log(`is sold out ${isSoldOut}, `, `has variants ${hasVariants}, `, `has class ${hasClass}`);
  
      if(hasVariants == 1){
        // console.log('has variants');
        if(isSoldOut == 0){
          // console.log('is sold out');
          $(this).removeClass('show-color-swatches');
          $(this).find('.product-info__variant-picker').addClass('is-sold-out');
        } else{
          // console.log('has variant + not sold out');
          $('.variant-picker__option-values a.is-selected').addClass('is-default');
          $('.is-default').addClass('is-selected');
          $(this).find('.ruk_rating_snippet').addClass('ruk_rating_hide');
          addVariantToCart();
        }
      } else{
        // console.log('Has no variants');
        $(this).find(".product-card__quick-buy").addClass('no-variant');
        $(this).find('.ruk_rating_snippet').addClass('ruk_rating_hide');
      }
      // console.log($(this).find(".variant-picker__option-values a.is-default"));
      setTimeout(() => {
        $(this).find(".variant-picker__option-values a.is-default").trigger('click'); // Trigger the default selected variant
      }), 100;
      }, function(){ // On hover out
      $(this).removeClass('show-color-swatches');
      $('.variant-picker__option-info p').remove();
      $('.variant-picker__option-values a').removeClass('is-selected');
      $(this).find('.product-info__variant-picker').removeClass('is-sold-out');
      $(this).find('.ruk_rating_snippet').removeClass('ruk_rating_hide');
    });
  }

  function colorSwatchMobile(){
    document.querySelectorAll('.product-list .product-card').forEach((productItem) => {
      productItem.querySelector('.product-card__figure > a').setAttribute("href", "javascript: void(0)");
      productItem.querySelector('span.product-card__title a').setAttribute("href", "javascript: void(0)");
      productItem.onclick = function() {
        if(productItem.querySelector('.product-info__variant-picker').classList.contains('active')) {
          productItem.querySelector('.product-info__variant-picker').classList.remove('active');
        } else {
          productItem.querySelector('.product-info__variant-picker').classList.add('active');
        }
      }
    })
  }

  function addVariantToCart(){
    $('.product-list .product-card .variant-picker__option-values a').click(function(e){
      e.preventDefault();
      // console.log($(this));
      $('.variant-picker__option-values a').removeClass('is-selected');
      $(this).addClass('is-selected');
      var data = $(this).attr('data-id');
      // console.log(data);
      $('.show-color-swatches .product-card__quick-buy form input:nth-child(3)').val(data);
      $.each($('.variant-picker__option-values a.is-selected'), function() {
        // console.log($(this).attr("data-tooltip"));
        var currentVariant = $(this).attr("data-tooltip");
        $('.variant-picker__option-info p').text(`${currentVariant}`);
      });
    });
  }

  // Will check if gift cards page
  if (window.location.pathname == '/collections/gift-cards'){
    // console.log('YES Gifts cards');
    $('.product-card__quick-buy').addClass('single-button');
  } else if ($(window).width() < 1181) {
    colorSwatchMobile(); // Call the function
    document.querySelectorAll('body product-card .color-swatch').forEach((e) => {
      e.classList.remove('is-selected');
    })
  } else {
    colorSwatch(); // Call the function
  }

  // Modify the color on mobile menu icon
  $('.tabs-container .accordion .accordion__toggle').click(function(){
    $(this).toggleClass('pink-color');
  });

  // Will hide the extra column with no data on Cashmere's craving's 
  $.each($('.product-list .product-card'), function() {
    var findElement = $(this).find(".product-card__figure").length;
    // console.log(findElement);
    if(findElement == 0){
      // $(this).addClass('hidden-item');
      $(this).remove();
      $('.image-placeholder2').removeClass('hidden-item');
    }
  });

  // Will append the image from settings on Why we baked
  let imageToUse = $('.why-we-baked .uploaded-image img').attr("src");
  $('.why-we-baked img').attr("src", imageToUse);

  // Will reload the page on pagination
  $('.pagination__item').click(function(){
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.location.reload(true);
    }), 100;
  });

  // Will check if the page is on Custome Care
  if (window.location.pathname == '/pages/customer-care' || window.location.pathname == '/pages/customer-care#shipping'){
    $('.custom-accordion').click(function() {
      // console.log(this);
      $(this).find('.svg-arrow').toggleClass('svg-rotate');
    });
  }

  // Will check for event click on sort products
  $('#facet-form .accordion .checkbox-list .checkbox-container label').click(function() {
    setTimeout(() => {
      window.location.reload();
    }), 100;
  });

  $('#facet-form .accordion .checkbox-list .checkbox-container .checkbox').click(function() {
    setTimeout(() => {
      window.location.reload();
    }), 100;
  });

  $('.facets-summary .active-facets .facet-clear-all').click(function(e) {
    e.preventDefault();
    setTimeout(() => {
      window.location.reload();
    }), 100;
  });

  $('#facet-form .accordion .accordion__toggle .switch').click(function() {
    setTimeout(() => {
      window.location.reload();
    }), 100;
  });

  $('#facet-form #accordion-filter-v-price .accordion__content input[type=range]').change('mousestop',function () {
    // console.log('Triggered');
    setTimeout(() => {
      window.location.reload();
    }), 100;
  });
  
});

// Will check if Customer page
if (window.location.pathname == '/pages/customer-care' || window.location.pathname == '/pages/customer-care#shipping'){
  // console.log('is Customer care');
  $('.footer .footer__block:nth-child(3) li:nth-child(2) a').click(function(){
    window.scrollTo(0, 0);
    setTimeout(() => {
      document.getElementById("defaultOpen").click();
    }), 100;
  });
  document.getElementById("defaultOpen").click();
} else{
  // console.log('!Not customer care page');
}

// Remove the hover on mobile screens starting on ipad
// $(window).resize(removeFunctions); // When window resize

// function removeFunctions() {
//     if($(window).width() < 1181) {      
//       $('.product-list .product-card img').unbind();
//     }
// }

// Custom Tab
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
    
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
    
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
    
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Custom Accordion
var acc = document.getElementsByClassName("custom-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("current");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.classList.remove('text');
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.classList.add('text');
    }
  });
}

// Check inventory on PDP
async function productData() {
  let getCurrentURL = window.location.pathname + '.json';
  let response = await fetch(getCurrentURL);
  // console.log(response.status); // 200

  if (response.status === 200) {
    let data = await response.json();
    let inventoryCount = data.product.variants[0].inventory_quantity;
    // console.log(inventoryCount);
    if(inventoryCount == 0){
      console.log(`Has ${inventoryCount}`);
    } else if(inventoryCount >= 21){ // if greather than the quantity
      console.log(`Still has ${inventoryCount}`);
    } else{
      console.log(`We are on the threshold of 20 items`);
      let backToStock = document.querySelector(".product-info .product-info__badge-list");
      let soldOutBadge = document.querySelector(".product-info .product-info__price .rating-with-text .product-info__badge-list .badge--sold-out");
      let inventoryWidget = document.querySelector(".product-info .product-info__inventory");
      let notifyMeEmailBox = document.querySelector(".product-info .product-info__buy-buttons .productContactForm");
      let addToCartButton = document.querySelector(".product-info .product-info__buy-buttons .shopify-product-form");
      backToStock.remove();
      inventoryWidget.remove();
      soldOutBadge.classList.add("not-hidden");
      notifyMeEmailBox.classList.add("not-hidden");
      //addToCartButton.remove();
    }
  }
}

productData();